// /canvas — real route (design doc's G2). The original (app/canvas/page.tsx)
// is already a pure `'use client'` page with no server auth gate (design doc
// §1b lists `/canvas` among the pages with "no server auth gate today; the
// APIs 401"). The scaffold placed this under `_authed` already
// (routes/agents.tsx) — design doc §1b calls that "a strict improvement, not
// parity debt", so it's kept rather than moved to core.tsx. Mounts
// `<CanvasView sessionId={null} />` exactly like the original
// (app/canvas/page.tsx:6-8). `/canvas/$id` is a separate placeholder route
// (routes/agents.tsx) not owned by this file. Registered into the route
// tree from routes/agents.tsx.
import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { authedRoute } from './guards';

const CanvasPage = lazy(() =>
  import('@/app/canvas/page').then((m) => ({ default: m.default })),
);

export const canvasRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: '/canvas',
  component: CanvasPage,
});
